/**
 * 출생지 좌표: 서울 구는 대략 중심 좌표, 그 외 시·군·구는 도 단위 기준점 +
 * 목록 내 인덱스 기반 소량 오프셋으로 구별(차트 미세 차이용).
 * 타임존은 대한민국 영토 전역 Asia/Seoul 로 고정합니다.
 */

const TZ = "Asia/Seoul";

/** BirthForm 드롭다운과 동일한 키·순서(중복 항목은 첫 등장 순서 유지). */
export const KOREA_LOCATION_TREE = {
  경기도: [
    "수원시", "고양시", "용인시", "성남시", "화성시", "부천시", "남양주시", "안산시", "안양시", "시흥시",
    "파주시", "평택시", "김포시", "광주시", "이천시", "양주시", "군포시", "오산시", "하남시", "양평군",
    "여주시", "동두천시", "안성시", "과천시", "의정부시", "포천시", "연천군", "가평군", "구리시", "의왕시",
  ],
  강원특별자치도: [
    "춘천시", "원주시", "강릉시", "동해시", "태백시", "속초시", "삼척시", "홍천군", "횡성군", "영월군",
    "평창군", "정선군", "철원군", "화천군", "양구군", "인제군", "고성군", "양양군",
  ],
  충청북도: [
    "청주시", "충주시", "제천시", "보은군", "증평군", "진천군", "괴산군", "음성군", "단양군", "영동군",
    "옥천군", "정성군",
  ],
  충청남도: [
    "천안시", "공주시", "보령시", "아산시", "서산시", "논산시", "계룡시", "당진시", "금산군", "부여군",
    "서천군", "청양군", "홍성군", "예산군", "태안군",
  ],
  전라북도: [
    "전주시", "군산시", "익산시", "정읍시", "남원시", "김제시", "완주군", "진안군", "무주군", "장수군",
    "임실군", "순창군", "고창군", "부안군",
  ],
  전라남도: [
    "목포시", "여수시", "순천시", "나주시", "광양시", "담양군", "곡성군", "구례군", "고흥군", "보성군",
    "화순군", "장흥군", "강진군", "해남군", "영암군", "무안군", "함평군", "영광군", "장성군", "완도군",
    "진도군", "신안군",
  ],
  경상북도: [
    "포항시", "경주시", "김천시", "안동시", "구미시", "영주시", "영천시", "상주시", "문경시", "경산시",
    "군위군", "의성군", "청송군", "영양군", "영덕군", "청도군", "고령군", "성주군", "칠곡군", "봉화군",
    "울진군", "울릉군",
  ],
  경상남도: [
    "창원시", "진주시", "통영시", "사천시", "김해시", "밀양시", "거제시", "양산시", "고성군", "남해군",
    "하동군", "창녕군", "함안군", "합천군", "거창군", "함양군", "산청군", "의령군",
  ],
  제주특별자치도: ["제주시", "서귀포시"],
  서울특별시: [
    "종로구", "중구", "용산구", "성동구", "광진구", "동대문구", "중랑구", "성북구", "강북구", "도봉구",
    "노원구", "은평구", "서대문구", "마포구", "양천구", "강서구", "구로구", "금천구", "영등포구", "동작구",
    "관악구", "서초구", "강남구", "송파구", "강동구",
  ],
  부산광역시: [
    "중구", "서구", "동구", "영도구", "부산진구", "동래구", "연제구", "강서구", "북구", "해운대구",
    "사하구", "금정구", "사상구", "기장군",
  ],
  대구광역시: ["중구", "동구", "서구", "남구", "북구", "수성구", "달서구", "달성군", "군위군"],
  인천광역시: ["중구", "동구", "미추홀구", "연수구", "남동구", "부평구", "계양구", "서구", "강화군", "옹진군"],
  광주광역시: ["동구", "서구", "남구", "북구", "광산구"],
  대전광역시: ["동구", "중구", "서구", "유성구", "대덕구"],
  울산광역시: ["중구", "남구", "동구", "북구", "울주군"],
  세종특별자치시: ["세종시"],
};

const PROVINCE_ANCHOR = {
  경기도: { lat: 37.29, lng: 127.02 },
  강원특별자치도: { lat: 37.82, lng: 128.15 },
  충청북도: { lat: 36.64, lng: 127.49 },
  충청남도: { lat: 36.52, lng: 126.8 },
  전라북도: { lat: 35.82, lng: 127.15 },
  전라남도: { lat: 34.87, lng: 126.99 },
  경상북도: { lat: 36.29, lng: 128.89 },
  경상남도: { lat: 35.44, lng: 128.69 },
  제주특별자치도: { lat: 33.38, lng: 126.55 },
  서울특별시: { lat: 37.5665, lng: 126.978 },
  부산광역시: { lat: 35.1796, lng: 129.0756 },
  대구광역시: { lat: 35.8714, lng: 128.6014 },
  인천광역시: { lat: 37.4563, lng: 126.7052 },
  광주광역시: { lat: 35.1595, lng: 126.8526 },
  대전광역시: { lat: 36.3504, lng: 127.3845 },
  울산광역시: { lat: 35.5384, lng: 129.3114 },
  세종특별자치시: { lat: 36.4875, lng: 127.2817 },
};

/** 서울 구 단위 하드코딩 좌표(대략 행정구역 중심). */
const SEOUL_GU = {
  종로구: { lat: 37.5736, lng: 126.9789 },
  중구: { lat: 37.5646, lng: 126.9979 },
  용산구: { lat: 37.5388, lng: 126.9655 },
  성동구: { lat: 37.5507, lng: 127.0409 },
  광진구: { lat: 37.5388, lng: 127.0826 },
  동대문구: { lat: 37.5747, lng: 127.0398 },
  중랑구: { lat: 37.6078, lng: 127.0927 },
  성북구: { lat: 37.5898, lng: 127.0177 },
  강북구: { lat: 37.6399, lng: 127.0256 },
  도봉구: { lat: 37.6693, lng: 127.0469 },
  노원구: { lat: 37.6546, lng: 127.0568 },
  은평구: { lat: 37.6029, lng: 126.9293 },
  서대문구: { lat: 37.5796, lng: 126.9368 },
  마포구: { lat: 37.5636, lng: 126.9084 },
  양천구: { lat: 37.5177, lng: 126.8666 },
  강서구: { lat: 37.5512, lng: 126.8498 },
  구로구: { lat: 37.4958, lng: 126.8878 },
  금천구: { lat: 37.4526, lng: 126.902 },
  영등포구: { lat: 37.5265, lng: 126.8963 },
  동작구: { lat: 37.5126, lng: 126.9395 },
  관악구: { lat: 37.4784, lng: 126.9516 },
  서초구: { lat: 37.4839, lng: 127.0326 },
  강남구: { lat: 37.5172, lng: 127.0473 },
  송파구: { lat: 37.5146, lng: 127.1059 },
  강동구: { lat: 37.5304, lng: 127.1239 },
};

function round6(n) {
  return Math.round(n * 1e6) / 1e6;
}

/**
 * @param {string} province
 * @param {string} city
 * @returns {{ lat: number, lng: number, timezone: string }}
 */
export function getBirthCoordinates(province, city) {
  if (province === "서울특별시" && SEOUL_GU[city]) {
    return { lat: SEOUL_GU[city].lat, lng: SEOUL_GU[city].lng, timezone: TZ };
  }

  const anchor = PROVINCE_ANCHOR[province] || PROVINCE_ANCHOR["서울특별시"];
  const list = KOREA_LOCATION_TREE[province];
  const idx = Array.isArray(list) ? list.indexOf(city) : -1;
  const i = idx >= 0 ? idx : 0;

  return {
    lat: round6(anchor.lat + i * 0.0028),
    lng: round6(anchor.lng + i * 0.0035),
    timezone: TZ,
  };
}
